import React from "react";
import "./Logo.css";

const Logo = ({ isDark = true }) => {
  return (
    <div className="d-flex logo-div">
      <div className="">
        <img
          src="../images/Logos/logo.png"
          alt="logo"
          className="logo-image"
          style={{
            width: isDark ? "" : "50px",
          }}
        />
      </div>
      <div className="my-auto">
        <span
          className={`logo-maintitle ${
            isDark
              ? "text-dark"
              : "text-light border-bottom border-1 border-white "
          }`}
          style={{
            fontSize: isDark ? "" : "0.8rem",
            textAlign: isDark ? "center" : "left",
          }}
        >
          OMNIA STEELS
        </span>
        <div
          className={`logo-subtitle ${isDark ? "text-dark" : "text-light"}`}
          style={{
            fontSize: isDark ? "" : "0.6rem",
          }}
        >
          <span className="logo-tm">TM</span>
          Trust us, we don't rust you
        </div>
      </div>
    </div>
  );
};

export default Logo;
